import React from 'react'
import PropTypes from 'prop-types'

import { Header } from './Header'
import { Footer } from './Footer'

const Layout = ({ children, showFooter = true }) => {
  return (
    <div className="page-frame">
      <div className="page-body">
        <Header />
        {children}
        {showFooter && <Footer />}
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  showFooter: PropTypes.bool,
}

export default Layout
